import script from "./LoginCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginCheck.vue?vue&type=script&setup=true&lang=js"

import "./LoginCheck.vue?vue&type=style&index=0&id=9b1b7ff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b1b7ff2"]])

export default __exports__